import React, { memo } from 'react';
import useLazyRender from '@hooks/use-lazy-render';

import { NestedCheckboxOption } from '../components/nested-checkbox-option';
import { NestedCheckboxItem } from '../src/nested-checkbox-list.type';

interface LazyNestedCheckboxItemProps {
  item: NestedCheckboxItem;
  onSelect: (id: string, selectChildren?: boolean, parentId?: null) => void;
  isSelected: (id: string) => boolean;
  isExpanded?: boolean;
  checkboxOptionClassName?: string;
  customStyles?: React.CSSProperties;
}

const LazyNestedCheckboxItem: React.FC<LazyNestedCheckboxItemProps> = ({
  item,
  onSelect,
  isSelected,
  isExpanded = false,
  checkboxOptionClassName,
  customStyles,
}) => {
  const [lazyRef, isVisible] = useLazyRender(); // Hook called at top level

  return (
    <div ref={lazyRef}>
      {isVisible ? (
        <NestedCheckboxOption
          item={item}
          onSelect={onSelect}
          isSelected={isSelected}
          isExpanded={isExpanded}
          checkboxOptionClassName={checkboxOptionClassName}
          customStyles={customStyles}
          depth={0}
        />
      ) : (
        <div style={{ height: '50px' }} /> // Placeholder until visible
      )}
    </div>
  );
};

export default memo(LazyNestedCheckboxItem); // Memoized for performance
